import { styled } from '@material-ui/core/styles';
import { css } from '@emotion/core';
import { IconButton } from '@material-ui/core';

import { ICustomTheme } from 'interfaces';

export const CloseButton = styled(IconButton)(
  ({ theme }: { theme: ICustomTheme }) => ({
    position: 'absolute',
    right: theme.spacing(2),
    top: theme.spacing(2),
  }),
);

export const cssButton = (theme: ICustomTheme) =>
  css({
    width: 'auto',
    minWidth: 192,
    height: 'auto',
    minHeight: 48,
    whiteSpace: 'nowrap',
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down('sm')]: {
      minHeight: 32,
      whiteSpace: 'initial',
      minWidth: 'unset',
    },
  });

export const cssDialogTitle = (theme: ICustomTheme) =>
  css({
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    textAlign: 'center',
  });

export const cssTitle = (theme: ICustomTheme) =>
  css({
    textTransform: 'none',
    color: theme.colors.paletteFromBO.main,
  });

export const cssDialogContentText = (theme: ICustomTheme) =>
  css({
    lineHeight: 1.3,
  });

export const cssDialogActions = (theme: ICustomTheme) =>
  css({
    justifyContent: 'center',
  });
